import styled from "styled-components";
import { colors, types } from "../../../libs";
import { Button, Container, Modal } from "react-bootstrap";

export const ModalHeader = styled(Modal.Header)`
  background:  ${colors.background.lightBlack};
  color: ${colors.text.mediumWhite};
  border: none;
  padding: 15px 20px;
  color: ${colors.text.mediumWhite};
  border: none;
  padding: 15px 20px;
  position: sticky;
  top: 0;
  z-index: 10;
`;


export const ModalBodyWrapper = styled.div`
  height: calc(100vh - 70px);
  overflow-y: auto;
  padding: 16px 20px;
`;

export const StyledContainer = styled(Container)`
  padding-top: 16px;
  max-width:1111px
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 16px;
`;

export const LeftSection = styled.div`
  ${types.headers.itemMedium};
  display: flex;
  align-items: center;
  gap: 8px;
`;


export const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const SaveButton = styled(Button)`
  margin-left: 8px;
`;

export const Description = styled.p`
  ${types.body.normal};
  color: ${colors.text.gray};
  margin-top: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const TitleCellWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
`;

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.div`
  ${types.body.normal};
  font-weight: bold;
  color:  ${colors.text.white};
  color: white;
`;

export const Subtitle = styled.div`
   ${types.body.small};
  color: ${colors.text.gray};
`;

export const Thumbnail = styled.img`
  object-fit: cover;
  width: 90px;
  height: 60px;
`;

export const StyledNumberInput = styled.input<{ isValid: boolean }>`
${types.body.normal};
  width: 40px;
  text-align: center;
  border: ${({ isValid }) => (isValid ? `1px solid ${colors.text.gray}` : `1px solid ${colors.text.error}`)};
  border-radius: 4px;
  appearance: textfield;
  -moz-appearance: textfield;

  /* Hide arrows for Chrome, Safari, Edge */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export const ClickableIndex = styled.span`
  cursor: pointer;
    width: 100%;
    display: flex;
    height: 50px;
    align-items: center;
`;


export const DashboardSearchWrapper = styled.div``;

export const SearchBarWrapper = styled.div`
  position: relative;
  width: 254px;
`;

export const SearchInput = styled.input`
  width: 100%;
  border-radius: 20px;
  padding: 8px 50px;
  background: ${colors.background.smokyBlack};;
  color: ${colors.text.white};
  border: 1px solid rgba(255, 255, 255, 0.2);

  &:focus {
    outline: none;
  }
`;

export const SearchIcon = styled.img`
  position: absolute;
  left: 25px;
  top: 14px;
  z-index: 1;
`;  

export const CustomButton = styled(Button)<{
  longLabel?: boolean;
}>`
  width: 40px;
  padding: 6px; 
  overflow: hidden;
  white-space: nowrap;

  background: ${colors.background.lightBlack};
  color: ${colors.text.white};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: width 0.3s ease;

  &:hover {
    width: ${({longLabel}) => (longLabel ? '170px' : '100px')};
    padding: 6px 12px;
  }
`;

export const IconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 26px;
    height: 26px;
  }
`;

export const Label = styled.span`
  display: none;
  margin-left: 8px;
  opacity: 0;
  transform: translateX(-10px);
  transition:
    opacity 0.2s ease-out 0.15s,
    transform 0.2s ease-out 0.15s;

  ${CustomButton}:hover & {
    display: inline-block;
    opacity: 1;
    transform: translateX(0);
  }
`;